class ConfigQueryKeys {
  constructor(private prefix: string) {}

  getConfig() {
    return [this.prefix];
  }
}

export default ConfigQueryKeys;
